export const Options = {
    Salutation: [
        {text:"Frau",value:"Frau"},
        {text:"Herr",value:"Herr"},
        {text:"Divers",value:"Divers"}
    ],
    Country: [
        { text: "AT - Österreich", value: "AT" },
        { text: "BG - Bulgarien", value: "BG" },
        { text: "CA - Kanada", value: "CA" },
        { text: "CH - Schweiz", value: "CH" },
        { text: "CN - China", value: "CN" },
        { text: "DE - Deutschland", value: "DE" },
        { text: "EGY - Ägypten", value: "EGY" },
        { text: "ES - Spanien", value: "ES" },
        { text: "FR - Frankreich", value: "FR" },
        { text: "GB - Vereinigtes Königreich", value: "GB" },
        { text: "ID - Indonesien", value: "ID" },
        { text: "IN - Indien", value: "IN" },
        { text: "IR - Iran, Islamische Republik", value: "IR" },
        { text: "IT - Italien", value: "IT" },
        { text: "JP - Japan", value: "JP" },
        { text: "KP - Korea, Demokratische Volksrepublik", value: "KP" },
        { text: "KR - Korea, Republik", value: "KR" },
        { text: "LU - Luxemburg", value: "LU" },
        { text: "MAR - Marokko", value: "MAR" },
        { text: "MX - Mexiko", value: "MX" },
        { text: "NL - Niederlande", value: "NL" },
        { text: "PL - Polen", value: "PL" },
        { text: "RO - Rumänien", value: "RO" },
        { text: "SE - Schweden", value: "SE" },
        { text: "SK - Slowakei", value: "SK" },
        { text: "TH - Thailand", value: "TH" },
        { text: "US - Vereinigte Staaten", value: "US" },
        { text: "VN - Vietnam", value: "VN" },
        { text: "not listed", value: "---" },
    ],
    JobCategory: [
        {text:"Vollzeit", value: "Vollzeit" },
        {text:"Teilzeit", value: "Teilzeit" },
        {text:"Teilzeit oder Vollzeit", value: "Teilzeit oder Vollzeit" },
        {text:"Minijob", value: "Minijob" },
        {text:"Werkstudententätigkeit", value: "Werkstudententätigkeit" },
        {text:"Praktikum", value: "Praktikum" },
        {text:"Ferienjob", value: "Ferienjob" },
    ],
    BecomingAwareThrough: [
        {text:"Agentur für Arbeit",value: "Agentur für Arbeit" },
        {text:"Empfehlung durch Bekannte*n",value: "Empfehlung durch Bekannte*n" },
        {text:"Empfehlung durch Mitarbeiter* der Zimmer Group",value: "Empfehlung durch Mitarbeiter* der Zimmer Group" },
        {text:"Facebook",value: "Facebook" },
        {text:"Homepage",value: "Homepage" },
        {text:"Instagram",value: "Instagram" },
        {text:"Internetrecherche",value: "Internetrecherche" },
        {text:"LinkedIn",value: "LinkedIn" },
        {text:"Messe",value: "Messe" },
        {text:"Online-Stellenbörse",value: "Online-Stellenbörse" },
        {text:"Praktikum",value: "Praktikum" },
        {text:"Schule/Uni/FH",value: "Schule/Uni/FH" },
        {text:"XING",value: "XING" },
        {text:"Zeitung",value: "Zeitung" },
    ],
    AdditionalConsent: [
        "Ich bin damit einverstanden, dass meine Daten auch über eine konkrete Stellenbesetzung hinaus gespeichert werden und ich auf interessante Stellenangebote hingewiesen werde. Sollte dies der Fall sein, werde ich von der Zimmer Group informiert.",
        "Ich möchte, dass meine Daten gem. den Informationen der Datenschutzerklärung nach dem aktuellen Bewerbungsprozess gelöscht werden.",
    ]
}
